export default {
  rowKey: 'id',
  rowSelection: false,
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 180,
      fixed: 'left',
      ellipsis: true,
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      render: 'checkPhone',
      width: 160,
    },
    {
      title: '城市',
      dataIndex: 'cityName',
      width: 120,
      ellipsis: true,
    },
    {
      title: '分公司',
      dataIndex: 'orgName',
      width: 142,
      ellipsis: true,
    },
    {
      title: '客户来源',
      dataIndex: 'channelName',
      width: 250,
      ellipsis: true,
    },
    {
      title: '优化师',
      dataIndex: 'advertName',
      width: 100,
      ellipsis: true,
    },
    {
      title: '军种',
      dataIndex: 'channelTypeName',
      width: 100,
      ellipsis: true,
    },
    {
      title: '品牌',
      dataIndex: 'channelBrandName',
      width: 100,
      ellipsis: true,
      // render: 'businessLineRender',
    },
/*    {
      title: '总分归属',
      dataIndex: 'armyAffiliationName',
      width: 100,
      ellipsis: true,
    },*/
    {
      title: '创建日期',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 200,
      ellipsis: true,
    },
    {
      title: '撞单原因',
      dataIndex: 'dispatchExceptionDesc',
      width: 350,
      ellipsis: {
        showTitle: true,
        overlayInnerStyle: {
          width: 250,
          maxHeight: 200,
          overflowY: 'scroll'
        },
      },
    },
  ],
  search: [
    {
      name: 'id',
      label: '线索ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'phone',
      itemType: 'number',
      label: '客户电话',
    },
    {
      name: 'channelBrandId',
      label: '品牌',
      itemType: 'select',
      data: 'businessLines',
      key: 'id',
      labelKey: 'brandName',
      showSearch: 'true',
      events: ['filterOption:filterOption'],
    },
   /* {
      name: 'armyAffiliation',
      label: '总分归属',
      itemType: 'select',
      data: 'armyAffiliations',
      key: 'key',
      labelKey: 'description',
      showSearch: 'true',
      events: ['filterOption:filterOption'],
    },*/
    {
      name: 'channelIds',
      label: '客户来源',
      itemType: 'tree',
      data: 'channels',
      labelKey: 'label',
      key: 'id',
      treeCheckable: true,
      allowClear: true,
      showSearch: true,
    },

    {
      name: 'orgId',
      label: '分公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      events: ['onChange:onCompanyChange'],
    },
    {
      name: 'advertUserId',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'anchor',
      label: '优化师',
    },
    {
      name: 'cityAreaCode',
      itemType: 'select',
      key: 'regionCode',
      labelKey: 'regionName',
      data: 'cityArea',
      label: '城市',
    },
  ],
}
